import { ResourcePath } from "@/types/resource-path";
import login from "./login";
import contract from "./contract";
import common from "./common";
import nav from "./nav";
import user from "./user";
import enterpriseCertification from "./enterpriseCertification";

/**
 * 创建并定义好的语言文件在此载入，common文件为可能会被公用到的公用字段
 * 其他文件为模块或页面单独定义的字段
 */
export type LocaleModules = ResourcePath<{
  login: typeof login;
  contract: typeof contract;
  common: typeof common;
  nav: typeof nav;
  user: typeof user;
  enterpriseCertification: typeof enterpriseCertification;
}>;

/**
 * 字段的字符串合并连接
 * @param target
 * @param fields
 */
export const fieldsConnect = <Target extends Record<string, string[]>>(
  target: Target,
  fields: Array<keyof Target | string[]>
) => {
  const connectList: string[][] = [];

  fields.forEach((field) => {
    // 赋予额外自定义字段功能，不需要一定在Target内定义才能使用
    if (Array.isArray(field)) {
      connectList.push([...field]);
    } else if (target[field] !== undefined) {
      // 拷贝引用数据
      connectList.push([...target[field]]);
    }
  });

  const connectHeader = connectList.shift() || [];

  if (connectHeader.length) {
    connectList.forEach((connectItems) => {
      connectItems.forEach((field, index) => {
        if (connectHeader[index] !== undefined) {
          connectHeader[index] += field;
        }
      });
    });
  }

  return connectHeader;
};
